import React, { ReactNode } from 'react';
import { Text } from '@spotify-internal/encore-web';
import styles from './PageHero.module.scss';

export type PageHeroBackground =
  | { type: 'gradient'; artworkUrl?: string }
  | { type: 'image'; src: string };

type PageHeroProps = {
  title: string;
  subtitle: string;
  subtitleClassName?: string;
  background?: PageHeroBackground;
  className?: string;
  contentClassName?: string;
  children?: ReactNode;
};

export function PageHero({
  title,
  subtitle,
  subtitleClassName,
  background = { type: 'gradient' },
  className,
  contentClassName,
  children,
}: PageHeroProps) {
  return (
    <div className={[styles.hero, className].filter(Boolean).join(' ')}>
      {background.type === 'image' ? (
        <div className={styles.imageBackground} aria-hidden="true">
          <img className={styles.image} src={background.src} alt="" />
        </div>
      ) : (
        <div className={styles.gradientBackground} aria-hidden="true">
          {background.artworkUrl && (
            <div className={styles.artwork}>
              <img
                className={styles.artworkImage}
                src={background.artworkUrl}
                alt=""
              />
            </div>
          )}
        </div>
      )}
      <div
        className={[styles.content, contentClassName].filter(Boolean).join(' ')}
      >
        <div className={styles.textGroup}>
          <Text variant="headlineMedium" as="h1" className={styles.title}>
            {title}
          </Text>
          <Text
            variant="bodyMedium"
            semanticColor="textBase"
            className={
              subtitleClassName
                ? `${styles.subtitle} ${subtitleClassName}`
                : styles.subtitle
            }
          >
            {subtitle}
          </Text>
        </div>
        {children}
      </div>
    </div>
  );
}
